import React from 'react';
import { Link } from 'react-router-dom';
import '../static/css/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-inner">
        {/* Brand */}
        <div className="footer-brand-col">
          <Link to="/" className="footer-brand" aria-label="TypingMatrix home">
            <span className="footer-brand-text">TYPING<span className="footer-brand-accent">MATRIX</span></span>
          </Link>
          <p className="footer-tagline">Free typing practice for developers.<br />No sign-up. No ads on core features.</p>
          <p className="footer-copy">&copy; {currentYear} TypingMatrix. All rights reserved.</p>
        </div>

        {/* Practice links */}
        <nav className="footer-nav-col" aria-label="Practice pages">
          <h3 className="footer-nav-heading">Practice</h3>
          <ul className="footer-nav-list">
            <li><Link to="/practice" className="footer-link">Typing Test</Link></li>
            <li><Link to="/practice" className="footer-link">Practice Mode</Link></li>
            <li><Link to="/lessons" className="footer-link">Lessons</Link></li>
            <li><Link to="/bugmode" className="footer-link">Bug Mode</Link></li>
            <li><Link to="/features" className="footer-link">Features</Link></li>
          </ul>
        </nav>

        {/* Learn links */}
        <nav className="footer-nav-col" aria-label="Learning resources">
          <h3 className="footer-nav-heading">Learn</h3>
          <ul className="footer-nav-list">
            <li><Link to="/typing-test" className="footer-link">Typing Test Guide</Link></li>
            <li><Link to="/typing-speed" className="footer-link">Typing Speed</Link></li>
            <li><Link to="/typing-practice" className="footer-link">Typing Practice</Link></li>
            <li><Link to="/wpm" className="footer-link">What Is WPM?</Link></li>
            <li><Link to="/typing-tips" className="footer-link">Typing Tips</Link></li>
          </ul>
        </nav>

        {/* Company links */}
        <nav className="footer-nav-col" aria-label="Company pages">
          <h3 className="footer-nav-heading">Company</h3>
          <ul className="footer-nav-list">
            <li><Link to="/about" className="footer-link">About</Link></li>
            <li><Link to="/blog" className="footer-link">Blog</Link></li>
            <li><Link to="/contact" className="footer-link">Contact</Link></li>
            <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="footer-link">Terms of Service</Link></li>
          </ul>
        </nav>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <span className="footer-status">
          <span className="footer-status-dot" aria-hidden="true"></span>
          All systems operational
        </span>
        <span className="footer-made">Built for developers, by a developer.</span>
      </div>
    </footer>
  );
};

export default React.memo(Footer);
